import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=071eb9dc"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071eb9dc')) {
      api.createRecord('071eb9dc', component.options)
    } else {
      api.reload('071eb9dc', component.options)
    }
    module.hot.accept("./redirect.vue?vue&type=template&id=071eb9dc", function () {
      api.rerender('071eb9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/error-page/redirect.vue"
export default component.exports